import React from 'react';
import strings from 'utils/strings';
class RenderSubTableModal extends React.Component {
	constructor(props) {
		super(props);
	}
	componentDidMount() {}
	render() {
		return (
			<div
				className="lit-modal"
				onClick={() => {
					this.props.closeWindow();
				}}
			>
				<div
					className="subtable-island"
					onClick={(event) => {
						event.stopPropagation();
					}}
				>
					<h3>
						{strings.classOverview} för{' '}
						<b>{this.props.selectedClass}</b>
					</h3>
					{this.props.children}
				</div>
			</div>
		);
	}
}
export default RenderSubTableModal;
